import { toast } from "react-toastify";
import { privateRequest } from "../api/apiConfig/privateRequest";

const getToken = () => {
  if (localStorage.getItem("authUser") !== null) {
    const user = JSON.parse(localStorage.getItem("authUser"));
    return user.data.token;
  }
};

export const deleteFunc = async (url, deleteID, setReload) => {
  try {
    await privateRequest.delete(`/${url}/${deleteID}`);
    setReload((prevState) => {
      return !prevState;
    });
    showSuccessNotification(`Deleted Sucsessfully`);
  } catch (error) {}
};

export const viewCV = async (url, id) => {
  try {
    await privateRequest.get(`/${url}/${id}`);

    const config = {
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${getToken()}`,
        Accept: "application/pdf",
      },
    };
    privateRequest.post("cv/getCvInfo", config).then((response) => {
      var file = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    });
  } catch (error) {}
};

export const statusToggleFunc = async (url, id, setReload, value) => {
  try {
    await privateRequest.put(`/${url}/status/${id}`);
    setReload((prevState) => {
      return !prevState;
    });
    showSuccessNotification(value ? `Active` : "In-Active");
  } catch (error) {}
};
export const addDataFunc = async (url, values, setReload) => {
  try {
    await privateRequest.post(`/${url}`, values);
    setReload((prevState) => {
      return !prevState;
    });
    showSuccessNotification(`Data Added Successfully`);
  } catch (error) {
    //showErrorNotification(error.response.data.message);
  }
};

export const updateDataFunc = async (url, values, setReload) => {
  try {
    await privateRequest.put(`/${url}/${values.id}`, values);
    setReload((prevState) => {
      return !prevState;
    });
    showSuccessNotification(`Data Added Successfully`);
  } catch (error) {
    //showErrorNotification(error.response.data.message);
  }
};
//TOASTER
export const configToast = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
  progress: undefined,
};

export const showSuccessNotification = (message) => {
  return toast.success(message, configToast);
};

export const showErrorNotification = (message) => {
  return toast.error(message, configToast);
};

export const showDeleteNotification = (message) => {
  return toast.success(message, configToast);
};

export const languageOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest("/coding-language");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};
export const ideOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/ide");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};

export const frameworkOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/framework");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};

export const versionControlOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/version-control");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};

export const googleComponentOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/external-component");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};

export const operatingSystemOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/os");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};
export const designationOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/designation");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};

export const webServicesOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/web-service");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};

export const technologyOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/coding-language");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};

export const toolsOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/tool");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};

export const otherSkillsOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/skill");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};

export const responsibilityOptionsUtility = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/responsibility");

  const tOptions = data?.data.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
      };
    });
  return tOptions;
};

export const projectStackOptionsUtility = async () => {
  const { data } = await privateRequest.get("/project/stacks");

  const tOptions = data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt.masterName,
        options: opt.stacks.map((stk) => {
          return {
            label: stk.name,
            value: { lId: stk.id, cId: opt.masterName },
          };
        }),
      };
    });
  return tOptions;
};

export const rolesOptionsUtility = async () => {
  const { data } = await privateRequest.get("/role");

  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt.roleName,
        value: opt.id,
      };
    });
  return tOptions;
};

// export const resourcesListCount = async () =>{
//   const { data } = await privateRequest.get('/cv/dashboard/count');
//   const tOptions = data?.data?.data?.filter(filterData => filterData.isActive==true).map(opt => {
//       return {
//           label: opt.roleName,
//           value: opt.id,
//         }
//       })
//       return tOptions
//   }

export const resourcesNameList = async () => {
  const { data } = await privateRequest.get("/user");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt.name,
        value: opt.id,
      };
    });
  return tOptions;
};

export const vendorNameList = async (label_name, value_name) => {
  const { data } = await privateRequest.get("/vendor");
  const tOptions = data?.data?.data
    ?.filter((filterData) => filterData.isActive == true)
    .map((opt) => {
      return {
        label: opt[label_name],
        value: opt[value_name],
        // label: opt.name,
        // value: opt.id,
      };
    });
  return tOptions;
};
